import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  sectionContainer: { gap: theme.spacing(2), width: '100%', margin: theme.spacing(4) },
  sectionHeader: { width: '100%' },
  card: {
    padding: theme.spacing(8),
    width: '100%',
    backgroundColor: theme.colorPalette.beige_25,
    // Reskin: section bodies are white inside the outlined card; nested items stay beige insets.
    ...reskinStyles(theme, { backgroundColor: theme.colors.card_background_primary_editable })
  },
  textareaField: {
    width: '100%'
  }
});

export default makeStyles(styles);
